var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posterContainer"},[_vm._m(0),_c('a',{staticClass:"poster",class:{
      active: _vm.poster,
      animate: _vm.animate
    },style:({ backgroundImage:("url(" + _vm.backgroundImage + ")") }),attrs:{"target":"_blank","href":_vm.poster.ExternalLink}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tapes"},[_c('div',{staticClass:"tape"}),_c('div',{staticClass:"tape"})])}]

export { render, staticRenderFns }